import { ChangeDetectionStrategy, Component, OnInit } from "@angular/core";
import { PostsInterface } from "../../../@core/models/site-material-data.model";
import {
  FakePostInterface,
  PostInterface,
} from "../../../@core/models/blog.model";
import { BlogService } from "../../../@core/services/blog.service";
import * as Sentry from "@sentry/browser";
import { environment } from "src/environments/environment";
import { BehaviorSubject, Subscription } from "rxjs";
import { DataService } from "src/app/@core/services/data.service";
import { FontsService } from "src/app/@core/services/fonts.service";


@Component({
  selector: "app-posts",
  templateUrl: "./posts.component.html",
  styleUrls: ["./posts.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MaterialPostsComponent implements OnInit {
  onBlog: boolean = true;
  data: PostsInterface;
  title: string;
  titleSize: string;
  subTitle: string;
  textColor: string = '';
  titleColor: string = '';
  fontWeight: string = '';
  backgroundColor: string;
  activatePadding: boolean = false;
  displayLoadMore: boolean = false;
  position: number = 0;
  moduleInfo: string;
  subscription: Subscription;
  loading: boolean = true;
  allElementAnimation: string;
  textAnimation: string;
  itemsAnimation: string;
  displayDescription: boolean = true;
  displayCategory: boolean = true;
  shadowEffect: boolean = true;
  borderRadius: string = '';
  // tslint:disable-next-line:no-unused-expression
  articles$: BehaviorSubject<FakePostInterface[] | PostInterface[]> = new BehaviorSubject<FakePostInterface[] | PostInterface[]>(null);
  articles: FakePostInterface[] | PostInterface[];
  titleFontFamily: string;
  titleFontFamilyName: string;

  constructor(private blogService: BlogService, private fontsService:FontsService , private dataService: DataService) {
    Sentry.configureScope(function (scope) {
      scope.setTag("component", "PostsComponent");
    });
  }

  ngOnInit(): void {
    if (this.data.animation) {
      this.allElementAnimation = this.data.animation.allElement != '' ? this.data.animation.allElement : undefined;
      this.textAnimation = this.data.animation.text != '' ? this.data.animation.text : undefined;
      this.itemsAnimation = this.data.animation.items != '' ? this.data.animation.items : undefined;

    }
    this.loading = false;
    const pattern = "<\\w+(\\s+(\"[^\"]*\"|\\'[^\\']*'|[^>])+)?>|<\\/\\w+>";
    const reg = new RegExp(pattern, "gi");
    this.subscription = this.blogService.getAllArticles().subscribe((articles) => {
      articles = articles.sort((article1:PostInterface,article2:PostInterface)=>{
          if(article1.order>article2.order) return 1;
          else if(article1.order<article2.order) return -1;
          else return 0;
      });
      if (articles.length > 3) {
        this.displayLoadMore = true;
      }
      let tempArticles = JSON.stringify(articles);
      let reg = /https:\/\/dev-sitecreator-v1-serverless-s3-blog-bucket.s3.amazonaws.com/g;
      tempArticles = tempArticles.replace(reg, environment.blogFrontGalleryLinkDev);
      reg = /https:\/\/prod-sitecreator-v1-serverless-s3-blog-bucket.s3.amazonaws.com/g;
      tempArticles = tempArticles.replace(reg, environment.blogFrontGalleryLinkProd);
      articles = JSON.parse(tempArticles);
      if (articles.length === 0) {
        this.onBlog = false;
      } else {
        articles.map((element) => {
          // element['linkTitle'] = element.title.replace(/ /g, '-');
          element["linkTitle"] = element.title.replace(/ /g, "-");
          element['linkTitle'] = encodeURIComponent(element['linkTitle']);
          return element;
        });
        this.articles$.next(articles.splice(0, 3));
      }
    });
    this.moduleInfo = JSON.stringify({ position: this.position, new: false });
    this.title = this.data.title;
    this.titleSize = this.data.titleSize ? this.data.titleSize : "";
    this.fontWeight = this.data.fontWeight;
    this.subTitle = this.data.subTitle;
    this.displayCategory = this.data.displayCategory !== undefined  ? this.data.displayCategory: true;
    this.displayDescription = this.data.displayDescription !== undefined  ? this.data.displayDescription: true;
    this.shadowEffect = this.data.shadowEffect !== undefined  ? this.data.shadowEffect: true;
    this.backgroundColor = this.data.backgroundColor
      ? this.data.backgroundColor
      : "";
    this.titleColor = this.data.titleColor ? this.data.titleColor : this.data.textColor;
    this.borderRadius = this.data.borderRadius ? this.data.borderRadius : '16';
    this.textColor = this.data.textColor ? this.data.textColor : this.dataService.getDefaultColor(this.backgroundColor);
    this.titleFontFamily = this.data.titleFontFamily ? this.data.titleFontFamily : '';
    if(this.titleFontFamily){
      this.fontsService.AddFont(this.titleFontFamily);
      this.titleFontFamilyName = this.titleFontFamily.replace(/\+/g, " ")
    }
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
